export enum Gender {
  Male,
  //HOMBRE = MALE
  Female,
  //MUJER = Female
  None
}
